var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 444 444",
    style: {
      enableBackground: "new 0 0 444 444"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFEEDA;}\n\t.st1{fill:#EBC28E;}\n\t.st2{fill:#101010;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 444,
    height: 444
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.4,262V110.6c-0.2-12.7-10.3-22.9-23-22.9h-158c-34.1,0.5-61.5,28.4-61.5,62.6c0,11.5,3.1,21.4,7.8,30.1 c4,7.2,10.3,14,16.5,19.1c1.8,1.4,0.9,0.8,6.3,4.1c7.4,4.5,15.9,6.8,15.9,6.8l-0.1,90.6c0.2,4.3,0.6,8.4,1.8,12.3 c3.5,12.8,12.4,22.6,24.4,27.3c5,2,10.7,3.3,16.8,3.4l126.2,0.4c25.1,0,45.5-20.4,45.5-45.6C352.1,283.8,344.6,270.4,333.4,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.5,299.9C336,316,322.7,329,306.4,329l-86.8-0.3c6.9-8,11.1-18.4,11.1-29.8c0-17.8-10.6-30.1-10.6-30.1 h86.4c16.6,0,30.1,13.5,30.1,30.1L336.5,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.5,186.7c-10-9.5-17-21.7-17-36.3v-1.5c0.8-24.8,21.2-44.8,46-45.5h158c4.1,0.2,7.4,3.1,7.4,7.3v133.7 c3.6,0.6,5.4,1.1,8.9,2.4c2.8,1,6.6,3.2,6.6,3.2V110.7c-0.2-12.7-10.3-22.9-23-22.9h-158c-34.1,0.5-61.5,28.4-61.5,62.6 c0,19.9,9.1,36.9,23.9,48.8c1,0.8,2,1.9,4.6,1.9c4.6,0,7.9-3.7,7.7-7.7C127.1,190,125.6,188.8,123.5,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.4,253.2H182.5c-8.3,0.1-15,6.8-15,15.1v17.8c0.2,8.2,7.2,15.2,15.6,15.2h9.2v-15.2H183v-17.4 c0,0,2.3,0,5,0c15.7,0,27.2,14.5,27.2,30.1c0,13.8-12.6,31.4-33.6,30c-18.6-1.2-28.7-17.8-28.7-30v-151c0-6.8-5.6-12.4-12.4-12.4 h-12.4v15.5h9.2v148c-0.5,30.1,21.4,45.2,44.3,45.2l124.9,0.4c25.1,0,45.5-20.4,45.5-45.6C352.1,273.7,331.6,253.2,306.4,253.2z  M336.5,299.9C336,316,322.7,329,306.4,329l-86.8-0.3c6.9-8,11.1-18.4,11.1-29.8c0-17.8-10.6-30.1-10.6-30.1h86.4 c16.6,0,30.1,13.5,30.1,30.1L336.5,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273,153.7h-93.4v-15.5H273c4.2,0,7.7,3.4,7.7,7.7C280.8,150.2,277.4,153.7,273,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273,226.4h-93.4V211H273c4.2,0,7.7,3.4,7.7,7.7C280.8,222.9,277.4,226.4,273,226.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.5,190H179.6v-15.5h109.8c4.2,0,7.7,3.4,7.7,7.7C297.3,186.5,293.8,190,289.5,190z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.673577c8260b63ae56867bc9af6af514.svg";
export { ForwardRef as ReactComponent };